import React from 'react';
import { useLocation } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import cx from 'classnames';
import { cardRowCount } from 'volto-uni-bonn/components/Columns/cardRows';

import { getColumns } from '@eeacms/volto-columns-block/ColumnsBlock/utils';
import { getStyle } from '@eeacms/volto-columns-block/Styles';

const ColumnsBlockView = (props) => {
  const location = useLocation();
  const { data = {} } = props.data;
  const metadata = props.metadata || props.properties;
  const columnList = getColumns(data);
  const cardRows = cardRowCount(columnList);
  const totalWidth = columnList.reduce(
    (sum, [, column]) => sum + column.width,
    0,
  );
  const customId = props.data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');

  return (
    <div className="columns-view" id={customId}>
      <Grid
        columns={12}
        style={{
          '--bonn-grid-units': totalWidth,
          '--bonn-card-rows': cardRows,
        }}
        className={cx('column-grid', {
          'reverse-wrap': props.data.reverseWrap,
          'bonn-card-grid': cardRows > 0,
        })}
      >
        {columnList.map(([id, column]) => {
          return (
            <Grid.Column
              key={id}
              mobile={12}
              tablet={(12 * column.width) / totalWidth}
              computer={(12 * column.width) / totalWidth}
              className={cx(
                'column-blocks-wrapper',
                `bonn-column-width-${column.width}`,
                column.settings?.column_class,
              )}
              {...getStyle(column.settings || {})}
            >
              <RenderBlocks
                {...props}
                location={location}
                blockWrapperTag="div"
                metadata={metadata}
                content={column}
              />
            </Grid.Column>
          );
        })}
      </Grid>
    </div>
  );
};

export default ColumnsBlockView;
